// extracted by mini-css-extract-plugin
export var standaloneTable = "_gx-0";
export var withExtraHeader = "_gx-1";